var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.719,
    height: 93.719,
    viewBox: "0 0 93.719 93.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.499 7.311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M219.443,48.482a27.506,27.506,0,0,0-33.058-5.2,1.831,1.831,0,1,0,1.778,3.2,23.8,23.8,0,1,1-9.536,9.532,1.831,1.831,0,0,0-3.208-1.765c-.112.2-.312.584-.5.975h0a27.462,27.462,0,1,0,44.527-6.745Z",
    transform: "translate(-172.081 -39.94)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.549,10.171a34.786,34.786,0,0,0-52.77,45l-5.7,5.7a5.492,5.492,0,0,0-6.252,1.074L2.685,78.091A9.152,9.152,0,1,0,15.628,91.035L31.768,74.9a5.492,5.492,0,0,0,1.074-6.252l5.7-5.706a34.786,34.786,0,0,0,45-52.769ZM29.179,72.308,13.038,88.446A5.491,5.491,0,0,1,5.273,80.68L21.411,64.54a1.832,1.832,0,0,1,2.588,0l5.179,5.179A1.832,1.832,0,0,1,29.179,72.308Zm1.294-6.472-2.59-2.59L33.1,58.034c.409.454.829.9,1.259,1.329s.875.851,1.329,1.26ZM80.96,56.774a31.123,31.123,0,1,1,0-44.014A31.074,31.074,0,0,1,80.96,56.774Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.998 14.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.222,81.505a.521.521,0,0,0-.044-.048,1.832,1.832,0,0,0-2.59,2.59c.016.016.031.031.048.046a1.831,1.831,0,0,0,2.587-2.589Z",
    transform: "translate(-213.052 -80.922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ffcda01fabdf5cfa4e32b456b551d1c5.svg";
export { ForwardRef as ReactComponent };